import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

declare module '@angular/forms' {
  interface FormBuilder {
    allocateFormArrays(form: FormGroup, input: object): void;
  }
}

FormBuilder.prototype.allocateFormArrays = function (form: FormGroup, input: object): void {
  for (const [key, value] of Object.entries(input)) {
    const formObj = form.controls[key];
    if (formObj instanceof FormArray) {
      if (!Array.isArray(value)) {
        throw new Error('Expected array');
      }

      const defaultItem = formObj.controls[0];
      while (formObj.length > 0) {
        formObj.removeAt(0);
      }

      for (let index = 0; index < value.length; index++) {
        formObj.push(this.nonNullable.group(defaultItem.value, { validators: defaultItem.validator }));
      }
    }
    if (formObj instanceof FormGroup) {
      if (typeof value !== 'object') {
        throw new Error('Expected object');
      }

      this.allocateFormArrays(formObj, value as object);
    }
  }
};
